import axiosInstance from "../api/csAxios";
var httpURL = "";
console.log(httpURL);
console.log(window.httpURL);
var obj = { status: "Success", message: "", lstOpenIPO: [] };

function getOpenIpoListApi(cb) {
  httpURL = window.httpURL;
  axiosInstance({
    url: httpURL + "/a/ipo/open/list",
    method: "POST",
    withCredentials: true,
  })
    .then((response) => {
      obj.status = response.data.SvcStatus;
      obj.message = response.data.SvcMsg;

      if (response.data.SvcStatus === "Success") {
        obj.lstOpenIPO = response.data.lstIpo;
      }
      cb(obj);
    })
    .catch((error) => {
      obj.status = "Error";
      obj.message = error.message;
      cb(obj);
    });
}
function saveCounterRateApi(quoteWeaverId, counterRate, cb) {
  axiosInstance({
    url: httpURL + "/a/ipo/counter/save",
    method: "POST",
    params: { quoteWeaverId, counterRate },
    withCredentials: true,
  })
    .then((response) => {
      obj.status = response.data.SvcStatus;
      obj.message = response.data.SvcMsg;
      cb(obj);
    })
    .catch((error) => {
      obj.status = "Error";
      obj.message = error.message;
      cb(obj);
    });
}
function removeCounterRateApi(quoteWeaverId, cb) {
  axiosInstance({
    url: httpURL + "/a/ipo/counter/remove",
    method: "POST",
    params: { quoteWeaverId },
    withCredentials: true,
  })
    .then((response) => {
      obj.status = response.data.SvcStatus;
      obj.message = response.data.SvcMsg;
      cb(obj);
    })
    .catch((error) => {
      obj.status = "Error";
      obj.message = error.message;
      cb(obj);
    });
}
export { getOpenIpoListApi, saveCounterRateApi, removeCounterRateApi };
